import { render, staticRenderFns } from "./EditReferenceInfoModal.vue?vue&type=template&id=f0b8773e&scoped=true&"
import script from "./EditReferenceInfoModal.vue?vue&type=script&lang=js&"
export * from "./EditReferenceInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./EditReferenceInfoModal.vue?vue&type=style&index=0&id=f0b8773e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b8773e",
  null
  
)

export default component.exports